import getStore from '../store/store';
import { mutator } from 'satcheljs';
import setDeclineExistingCalendarEvents from '../../actions/setDeclineExistingCalendarEvents';
export default mutator(setDeclineExistingCalendarEvents, function (actionMessage) {
    var optionState = getStore().currentState;
    optionState.declineExistingCalendarEventsEnabled = actionMessage.option;
});
//# sourceMappingURL=setDeclineExistingCalendarEventsEnabledState.js.map